var map = {
	"./agreement.router.js": "b0dc",
	"./college.router.js": "65b5",
	"./course.router.js": "05b2",
	"./hbsgsl.router.js": "4494",
	"./home.router.js": "a1dd",
	"./personal.router.js": "4a12",
	"./special.router.js": "9904",
	"./study.router.js": "c77b",
	"./video.router.js": "3deb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9a40";